import { createElement } from 'react';

import { DOCS_SECTION_TONE, type DocSection } from '../model/docs.type';
import { resolveSectionIcon } from '../model/docsSectionIcon.type';

interface DocsSectionIconProps {
  section: Pick<DocSection, 'icon' | 'tone'>;
  /** rem 단위 크기 클래스. 자리마다 달라서 호출부가 정한다. */
  className?: string;
}

/**
 * 섹션 아이콘. 색은 `tone` 이 정하고, 아이콘은 `currentColor` 로 따라간다 —
 * 다크모드에서 따로 대응할 게 없다.
 *
 * 레지스트리에서 꺼낸 컴포넌트를 `<Icon />` 으로 쓰면 react-hooks 의
 * static-components 규칙이 "렌더 중 생성된 컴포넌트" 로 오인한다. 실제로는
 * 모듈 상수라 identity 가 고정이므로 `createElement` 로 직접 만든다.
 */
export function DocsSectionIcon({
  section,
  className = 'h-4 w-4',
}: DocsSectionIconProps) {
  return createElement(resolveSectionIcon(section.icon), {
    'aria-hidden': true,
    className: `${className} shrink-0 ${DOCS_SECTION_TONE[section.tone]}`,
  });
}
